import { types } from "../types/types";


const initialState = {
    drivers: [],
    activeDriver: null,
    showDriverTimings: false,
    driverTimingId: null
}

export const driverReducer = ( state=initialState, action )=> {

    switch (action.type) {
        case types.driverActiveSelected:
            return {
                ...state,
                activeDriver:action.payload
            }
        case types.driverActiveClear:
            return {
                ...state,
                activeDriver:null
            }
        // ACTIVE
        case types.driversLoading:
            return {
                ...state,
                drivers:[...action.payload]
            }
        case types.driverClearAll:
            return {
                ...state,
                drivers: [],
                activeDriver: null
            }
        case types.showTimingsDriver:
            return {
                ...state,
                showDriverTimings: !state.showDriverTimings
            }
        case types.driverTimingId:
            return {
                ...state,
                driverTimingId: action.payload
            }

        default:
            return state;
    }

}